(function (t) {
// pt_BR
t.add("label_previous", "Anterior", "KnpPaginatorBundle", "pt_BR");
t.add("label_next", "Pr\u00f3ximo", "KnpPaginatorBundle", "pt_BR");
})(Translator);
